import { createContext } from 'react';

export interface IUIContextType {
  hide: () => void;
  show: () => void;
  isShow: boolean;
}

export const uiContext = createContext<IUIContextType | null>(null);
